import axios from 'axios';
import { ServiceResponse } from '@/OptimusRoutes/interfaces';
import { RouteMonitorArgs, RouteMonitorPointResponseDto } from './routeMonitor.dto';

class Service {
	async get(args: RouteMonitorArgs): Promise<ServiceResponse<RouteMonitorPointResponseDto[]>> {
		const { id, day, cancelToken } = args;

		const params = { day };

		const { data } = await axios.get<ServiceResponse<RouteMonitorPointResponseDto[]>>(
			`/v2/trackingHistory/${id}/route-monitor`,
			{
				params,
				cancelToken,
			}
		);
		return data;
	}
}

const RouteMonitorService = new Service();

export default RouteMonitorService;
